import React, { useRef } from 'react'
import Header from './components/Header'
import Figures from './components/Figures'
import Prices from './components/Prices'
import Functions from './components/Functions'
import Footer from './components/Footer'

const App = () => {
  const pricesRef = useRef()
  const functionsRef = useRef()
  const handleScroll = ref => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  return (
    <>
      <Header
        handleScroll={handleScroll}
        functionsRef={functionsRef}
        pricesRef={pricesRef}
      />
      <Figures />
      <Prices pricesRef={pricesRef} />
      <Functions functionsRef={functionsRef} />
      <Footer />
    </>
  )
}

export default App
